export enum Comparison {
  'No Comparison' = 0,
  'Demographics of Residents Within 5 Miles of Branches' = 1,
  'FOM rules territory' = 2,
}
